import { render, staticRenderFns } from "./sexChart.vue?vue&type=template&id=2482cb98&"
import script from "./sexChart.vue?vue&type=script&lang=js&"
export * from "./sexChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports